import colors from '../foundation/colors';

export const popoverMenuButtonStyles = {
  _hover: { cursor: 'pointer' },
  background: colors.greyScale['100'],
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 14px',
  borderRadius: 'md',
  position: 'inherit',
  width: '100%',
  height: '40px',
  fontSize: 'sm',
  fontWeight: 'normal',
  textAlign: 'left',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

export const activeStyle = {
  color: colors.primaryScale['600'],
  boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`
};

export const hoverStyle = { cursor: 'pointer' };

export const buttonItemStyle = {
  hover: {
    bgColor: colors.primaryScale['50'],
    color: colors.primaryScale['600'],
    cursor: 'pointer',
    borderRadius: 'md'
  },
  color: colors.greyScale['600'],
  alignItems: 'center',
  bgColor: 'white',
  borderRadius: 'md',
  height: '40px',
  padding: '10px 14px',
  textStyle: 'bodyMd',
  textTransform: 'capitalize',
  fontWeight: '500',
  textAlign: 'left',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};
